<template>
  <div class="ui-content dashboard leader-sub">
    <OnlineTestReports testType="aits" />
  </div>
</template>

<script>
import OnlineTestReports from '@/components/student/Tests/OnlineTestReports.vue';
import constants from "@/utils/constants.js";

export default {
  name: 'AITSTestReports',
  
  components: {
    OnlineTestReports
  },
  
  data() {
    return {
      constants: constants
    };
  }
};
</script>

